import {useSuspenseQueries} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import environmentStore from '@di-shared/features/environment/environmentStore';
import {ReactNode, useEffect} from 'react';

interface RenderIfTireDataKrProps {
  vin: string;
  onNoData?: () => void;
  children: ReactNode;
}

function RenderIfTireDataKr({vin, onNoData = () => {}, children}: RenderIfTireDataKrProps) {
  const puid = environmentStore.getState().puid;
  const [{data: tireRecommendedData}, {data: tireBoundData}] = useSuspenseQueries({
    queries: [
      {
        queryKey: [getQueryKey(diApi.tire.getTireRecommended), vin, puid],
        queryFn: () =>
          diApi.tire.getTireRecommended({
            puid,
            vin,
          }),
      },
      //TODO: tire bound api 임
      {
        queryKey: [getQueryKey(diApi.tire.getBatteryStatus1), vin],
        queryFn: () =>
          diApi.tire.getBatteryStatus1({
            vin,
          }),
      },
    ],
  });
  useEffect(() => {
    if (!tireRecommendedData?.data || !tireBoundData?.data) {
      onNoData();
    }
  }, []);

  if (!tireRecommendedData?.data || !tireBoundData?.data) {
    return null;
  }
  return <>{children}</>;
}

export default RenderIfTireDataKr;
